import { render } from "./FraisPort.vue?vue&type=template&id=16767fdd&scoped=true"
import script from "./FraisPort.vue?vue&type=script&lang=js"
export * from "./FraisPort.vue?vue&type=script&lang=js"

import "./FraisPort.vue?vue&type=style&index=0&id=16767fdd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16767fdd"]])

export default __exports__